import React, { useState, useEffect } from "react";
import Modal from "common/Modal";
import CloudOffIcon from "@mui/icons-material/CloudOff";

export const ConnectionLostModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    window.showConnectionLostModal = () => setOpen(true);
    return () => delete window.showConnectionLostModal;
  }, []);

  if (!open) {
    return null;
  }

  return (
    <Modal
      title="Connection lost"
      superIconJSX={<CloudOffIcon />}
      closeLabel={null}
      applyLabel="RELOAD"
      onApply={() => window.location.reload()}
      content={() => (
        <div>
          The connection with your BQN seems to be lost. Please consider
          reloading the browser.
        </div>
      )}
    />
  );
};
